import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Footer from '../components/footer';
import Blog from '../components/blog';
import styled from 'styled-components';

// Responsive wrapper that provides generous padding on desktop,
// but reduces the padding on mobile for a cleaner look.
const PageWrapper = styled.div`
  background-color: black;
  padding: 10em 0; /* Top & bottom spacing */
  
  @media (max-width: 768px) {
    padding: 4em 0; /* Reduce spacing on mobile */
  }
`;

// Optional: Wrap the Blog component (or its container) in another styled-component
// if you need to restrict the max-width or add extra spacing.
const BlogContainer = styled.div`
  margin: 0 auto;
  max-width: 1200px;  /* Optional: constrain content width on large screens */
  padding: 0 1rem;
`;

const BlogPage = () => (
  <PageWrapper>
    <Container>
      <Row>
        <Col>
          <BlogContainer>
            <Blog />
          </BlogContainer>
        </Col>
      </Row>
    </Container>
    <Footer />
  </PageWrapper>
);

export default BlogPage;
